<template>
  <v-card
      class="mx-auto"
      tile
    >

      <AddBook
        @createbook="createBook"
      />

      <v-btn @click="chooseNoBook">No Book</v-btn>
      <template v-if="hasBooks">
        <label>Search: <input v-model="search" type="search"></label>
        <RecycleScroller
          class="scroller"
          :items="filteredBooks"
          :item-size="100"
          key-field="id"
          v-slot="{ item }"
        >
          <v-list-item two-line @click="chooseBook(item)">
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
              <v-list-item-subtitle>by <span>{{ item.author }}</span></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </RecycleScroller>
      </template>
  </v-card>
</template>

<script>
import { RecycleScroller } from 'vue-virtual-scroller'

import AddBook from './AddBook.vue'

export default {
  name: 'BookChooser',
  components: {
    RecycleScroller,
    AddBook
  },
  data () {
    return {
      search: ''
    }
  },
  computed: {
    hasBooks () {
      return this.books.length > 0
    },
    filteredBooks () {
      if (this.search.length > 3) {
        const q = this.search.toLowerCase()
        return this.books.filter((b) => {
          return (
            b.title.toLowerCase().indexOf(q) !== -1 ||
            b.author.toLowerCase().indexOf(q) !== -1
          )
        })
      }
      return this.books
    },
    books () {
      return this.$store.state.books
    },
    online () {
      return this.$store.state.online
    },
    loginUrl () {
      return this.$appConfig.LOGIN_URL
    }
  },
  methods: {
    createBook (book) {
      this.$emit('hasbook', book)
    },
    chooseBook (book) {
      this.$emit('hasbook', book)
    },
    chooseNoBook (book) {
      this.$emit('hasbook', null)
    }
  }
}
</script>

<style scoped>
@import '~vue-virtual-scroller/dist/vue-virtual-scroller.css';

.scroller {
  height: 100%;
  max-height: 80vh;
}

.book {
  height: 100px;
}
</style>
